import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { global } from '../../global/global';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  public urlGlobal: string;
  data: any;
  private userRole: any = new BehaviorSubject('');
  userObj = this.userRole.asObservable()
  constructor(private http: HttpClient) {
    this.urlGlobal = global.urlService;
  }
  public observer:Observable<any>;

  ngOnInit() {
    console.log("ngInit--service main service");
    this.observer = this.http.post(
      this.urlGlobal,
      {
        'request': 'REQUEST_CUSTOMER'
      }
    );

    // .subscribe((result: any) => {
    //   if (result) {
    //     console.log("data------");
    //     console.log(result);
    //     this.data = result.data;
       
    //   }
    // });
  }

  public getData(){
    return this.observer;
  }

  loadInfoClient(): any {
    if(this.data){
      return this.data;
    }
  }

  getListImages(): any {
    if(this.data){
      console.log("---list----", this.data.whereToPay)
      return this.data.whereToPay;
    }
  }

  getHeader(): any {
    return this.data.header;
  }

  getFooter(): any {
    return this.data.footer;
  }
  getUserInfo(data: any) {
    this.userRole.next(data)
  }
}
